<template>
  <div class="search-autocomplate" v-if="autoCompleteStatus" :style="style">
    <ul>
      <li @click="selectAutocomplate(item)" v-for="item in autoCompleteData.items">
        <div class="text" >
            <Organization :name="item.name" type="userName" :openid="item.memberKeyRaw" :useOpenData="item.useOpenData" ></Organization>
            <template v-if="item.account">[{{item.account}}]</template>
        </div>
        <div class="oneline">
            <Organization :name="item.department" type="departmentName" :openid="item.department" :useOpenData="item.useOpenData" ></Organization>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import Api from "./api/default";
import eventbus from "../common/eventbus";
import Organization from "@/component/organization";
export default {
  data() {
    return {
      subUid: null,
      autoCompleteStatus: false,
      autoCompleteData: null,
      autoCompleteVal: null,
      style: null
    };
  },
  props: {
    keyword: String,
    dimission: Boolean,
    AutoCompleteDocument: String,
    open_data_status: Boolean
  },
  components:{
      Organization
  },
  watch: {
    // 关键字搜索 监听
    keyword(cVal) {
      if (cVal) {
        if (this.autoCompleteVal && this.keyword == this.autoCompleteVal.name)
          return;
        let _this = this;
        let params = {
          isInternal: 1,
          page: 1,
          word: cVal,
          state: this.dimission ? 0 : 1
        };
        _this.$emit('dataLoaded',false)
        Api.getMemberList(params, function(data) {
          _this.autoCompleteData = data;
          _this.$emit('dataLoaded',true)
        });
      } else {
        this.subUid = null;
      }
      this.autoCompleteVal = null;
    },
    // 监听人员搜索联想的数据
    autoCompleteData(cVal) {
      if (cVal) {
        if (
          this.autoCompleteData &&
          this.autoCompleteData.pagination.totalCount > 0
        ) {
          this.autoCompleteStatus = true;
          this.initStyle();
        } else {
          this.autoCompleteStatus = false;
        }
      }
    }
  },
  methods: {
    // 关键词搜索
    getSubUid(cb) {
      if (this.keyword && !this.autoCompleteVal) {
        if (
          this.autoCompleteData &&
          this.autoCompleteData.pagination.totalCount > 0
        ) {
          this.selectAutocomplate(this.autoCompleteData.items[0]);
        } else {
          // 初始化数据
          this.autoCompleteData = null;
          cb(-1);
          return;
        }
      }
      cb(this.subUid);
    },
    // 选择搜索的人员
    selectAutocomplate(item) {
      this.autoCompleteStatus = false;
      this.autoCompleteVal = item;
      this.subUid = item.id;
      this.$emit("AutoCompleteChangeItem", item.name);
    },
    fromHTMlElement(el) {
      const display = document.defaultView.getComputedStyle(el).display;
      if (display === "contents" && el.children.length === 1) {
        // el has no layout at all, use its children instead.
        return fromHTMlElement(el.children[0]);
      }
      const rect = el.getBoundingClientRect();
      return {
        x: rect.left,
        y: rect.top,
        w: rect.width,
        h: rect.height
      };
    },
    initStyle() {
      let postion = this.fromHTMlElement(
        document.querySelector(this.AutoCompleteDocument)
      );
      this.style =
        "left: " +
        postion.x +
        "px; top: " +
        (postion.y + postion.h + document.documentElement.scrollTop) +
        "px;";
    },
    close() {
      this.autoCompleteVal = null;
      this.autoCompleteData = null;
      this.subUid = null;
      this.autoCompleteStatus = false;
    }
  },
  created() {
    eventbus.$on("closeAutoComplete", target => {
      this.close();
    });
  }
};
</script>

<style lang="less">
.search-autocomplate {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9999;
  width: 260px;
  background-color: white;
  border: solid 1px #cccccc;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  li {
    line-height: 20px;
    padding: 10px 10px;
    border-bottom: solid 1px #f0f0f0;
  }
  li:last-child {
    border-bottom: none;
  }
  li:hover {
    background-color: #dddddd;
  }
  .oneline {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #999999;
  }
}
</style>